import { render, staticRenderFns } from "./ShowBincardPeps.vue?vue&type=template&id=1dba5f0f&scoped=true&"
import script from "./ShowBincardPeps.vue?vue&type=script&lang=ts&"
export * from "./ShowBincardPeps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dba5f0f",
  null
  
)

export default component.exports